// extracted by mini-css-extract-plugin
export default {"introContainer":"LoxIntro_introContainer__408c1","introHeading":"LoxIntro_introHeading__PWS4A","introContent":"LoxIntro_introContent__r6n3r"};